import { useI18n } from '../../../i18n/index.js'

interface Props {
  name: string
}

export const SelfChatItemName = ({ name }: Props) => {
  const { $t } = useI18n()

  return (
    <span>
      {name}{' '}
      <span className="text-content-subdued text-xs">
        {/* eslint-disable-next-line react/jsx-no-literals */}
        {`(${$t({
          defaultMessage: 'You',
          id: 'Generics.You',
        })})`}
      </span>
    </span>
  )
}
